import { LiaStarSolid } from 'react-icons/lia';
import { MdAccountCircle } from 'react-icons/md';
import { formatRating } from '../utils';

function UserinfoInmyProfile({ user }) {
  return (
    <section className='shadow bg-p-wh p-6 flex flex-col md:flex-row justify-between gap-2'>
      {' '}
      <div className='flex flex-row gap-2 '>
        <MdAccountCircle className='text-4xl text-b-mc/70 ' />

        <div className='flex flex-col w-full'>
          <div className='flex flex-row justify-between w-full'>
            <span>{`${user?.first_name} ${user?.last_name} ${
              user?.other_name ? user?.other_name : ''
            }`}</span>

            <div className='h-5 w-8 overflow-hidden mt-4 pr-2'>
              <img
                src={user?.country?.flag}
                alt={user?.country?.name}
                className='w-fll h-full object-cover'
              />
            </div>
          </div>
          <div className='flex flex-col gap-1 text-xs text-s-bk'>
            <p className='flex flex-row gap-2 items-center '>
              Rating: {formatRating(user?.rating)}
              <span className='-m-2'>
                <LiaStarSolid className='text-green-500' />
              </span>
            </p>
            <p className=''>{`Oder completed: ${
              user?.trx_stats?.completed
            }  Buy: ${user?.trx_stats?.buy} Sell: ${user?.trx_stats?.sell}  ${
              user?.trx_stats?.cancelled ? user?.trx_stats?.cancelled : ''
            }`}</p>{' '}
          </div>
        </div>
      </div>
      <span className='w-[0.5px] bg-t-bk p'></span>
      <div className=''>
        <p className='text-xs text-s-bk'>Account Type</p>
        <p>{user?.user_type?.name}</p>
      </div>
      <span className='w-[0.5px] bg-t-bk p'></span>
      <div className='bg-green-500/10 text-green-500 px-4 py-2 flex flex-row gap-2 w-fit h-fit items-center rounded'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='20'
          viewBox='0 0 1024 1024'
        >
          <path
            fill='currentColor'
            d='M512 64a448 448 0 1 1 0 896a448 448 0 0 1 0-896zm-55.808 536.384l-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z'
          />
        </svg>
        <p>You are Verified</p>
      </div>
    </section>
  );
}

export default UserinfoInmyProfile;
